import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

const BarChartSection = ({
  configs,
  selectedConfigId,
  setSelectedConfigId,
  chartData,
}) => {
  const selectedConfig = configs.find((c) => c._id === selectedConfigId);

  return (
    <div className="w-full">
      <h3 className="text-sm font-semibold text-center text-[#123865] mb-2">
        {selectedConfig?.heading || "Bar Chart"}
      </h3>

      {configs.length > 1 && (
        <div className="mt-1 mb-1 flex justify-start">
          <select
            className="rounded-full border px-2 !py-1 text-xs text-black card-wrapper"
            value={selectedConfigId}
            onChange={(e) => setSelectedConfigId(e.target.value)}
          >
            {configs.map((cfg) => (
              <option key={cfg._id} value={cfg._id}>
                {cfg.heading}
              </option>
            ))}
          </select>
        </div>
      )}

        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={chartData}>
              <XAxis
                dataKey="label"
                stroke="#000"
                tick={{
                  angle: -30,
                  textAnchor: "end",
                  fontSize: 11,
                  // fill: "var(--dark-color)",
                }}
                interval={0}
                height={60}
              />
            <YAxis
              tick={{ fontSize: 10 }}
              label={{
                value: "Count",
                angle: -90,
                position: "insideLeft",
                style: { textAnchor: "middle", fontSize: 11 },
              }}
            />
            <Tooltip
              content={({ active, payload, label }) => {
                if (active && payload && payload.length) {
                  return (
                    <div className="bg-white px-3 py-2 shadow-md rounded-md border border-gray-200">
                      <p className="font-semibold text-gray-800">{label}</p>
                      <p className="text-sm text-gray-600">
                        Mentions:{" "}
                        <span className="font-bold">{payload[0].value}</span>
                      </p>
                    </div>
                  );
                }
                return null;
              }}
            />
            <Bar dataKey="value">
              {chartData.map((idx) => (
                <Cell
                  key={`cell-${idx}`}
                  fill="#004877"
                  cursor="pointer"
                />
              ))}
            </Bar>
            {/* <Bar dataKey="value" radius={[8, 8, 0, 0]} /> */}
          </BarChart>
        </ResponsiveContainer>
    </div>
  );
};

export default BarChartSection;
